import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Companies
export const getCompanies = () => axios.get(`${API_URL}/companies`);
export const getCompany = (id) => axios.get(`${API_URL}/companies/${id}`);
export const createCompany = (data) => axios.post(`${API_URL}/companies`, data);
export const updateCompany = (id, data) => axios.put(`${API_URL}/companies/${id}`, data);
export const deleteCompany = (id) => axios.delete(`${API_URL}/companies/${id}`);

// Locations
export const getLocations = (companyId) => axios.get(`${API_URL}/locations`, { params: { company_id: companyId } });
export const createLocation = (data) => axios.post(`${API_URL}/locations`, data);
export const updateLocation = (id, data) => axios.put(`${API_URL}/locations/${id}`, data);
export const deleteLocation = (id) => axios.delete(`${API_URL}/locations/${id}`);

// Employees
export const getEmployees = (params) => axios.get(`${API_URL}/employees`, { params });
export const getEmployee = (id) => axios.get(`${API_URL}/employees/${id}`);
export const createEmployee = (data) => axios.post(`${API_URL}/employees`, data);
export const updateEmployee = (id, data) => axios.put(`${API_URL}/employees/${id}`, data);
export const deleteEmployee = (id) => axios.delete(`${API_URL}/employees/${id}`);

// Perfil do próprio colaborador
export const getMyProfile = () => axios.get(`${API_URL}/me/profile`);
export const updateMyProfile = (data) => axios.put(`${API_URL}/me/profile`, data);

// Time Records
export const getTimeRecords = (params) => axios.get(`${API_URL}/time-records`, { params });
export const createTimeRecord = (data) => axios.post(`${API_URL}/time-records`, data);
export const correctTimeRecord = (id, data) => axios.put(`${API_URL}/time-records/${id}/correct`, data);
export const getWorkedHoursReport = (params) => axios.get(`${API_URL}/reports/worked-hours`, { params });
export const getVacationBalance = (params) => axios.get(`${API_URL}/reports/vacation-balance`, { params });

// Leave Requests
export const getLeaveRequests = (params) => axios.get(`${API_URL}/leave-requests`, { params });
export const createLeaveRequest = (data) => axios.post(`${API_URL}/leave-requests`, data);
export const respondLeaveRequest = (id, status, response) => 
  axios.put(`${API_URL}/leave-requests/${id}/respond`, { status, response });
export const updateLeaveRequest = (id, data) => axios.put(`${API_URL}/leave-requests/${id}`, data);
export const deleteLeaveRequest = (id) => axios.delete(`${API_URL}/leave-requests/${id}`);
export const createAdminLeave = (data) => axios.post(`${API_URL}/admin/leave`, data);

// Work Schedules
export const getSchedules = () => axios.get(`${API_URL}/schedules`);
export const createSchedule = (data) => axios.post(`${API_URL}/schedules`, data);
export const updateSchedule = (id, data) => axios.put(`${API_URL}/schedules/${id}`, data);
export const deleteSchedule = (id) => axios.delete(`${API_URL}/schedules/${id}`);
export const getScheduleAssignments = (params) => axios.get(`${API_URL}/schedules/assignments`, { params });
export const assignSchedule = (data) => axios.post(`${API_URL}/schedules/assign`, data);
export const deleteScheduleAssignment = (id) => axios.delete(`${API_URL}/schedules/assignments/${id}`);

// Folders
export const getFolders = (employeeId) => axios.get(`${API_URL}/folders`, { params: { employee_id: employeeId } });
export const createFolder = (data) => axios.post(`${API_URL}/folders`, data);
export const updateFolder = (id, data) => axios.put(`${API_URL}/folders/${id}`, data);
export const deleteFolder = (id) => axios.delete(`${API_URL}/folders/${id}`);

// Documents
export const getDocuments = (params) => axios.get(`${API_URL}/documents`, { params });
export const uploadDocument = (folderId, file) => {
  const formData = new FormData();
  formData.append('folder_id', folderId);
  formData.append('file', file);
  return axios.post(`${API_URL}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const downloadDocument = (id) => axios.get(`${API_URL}/documents/${id}/download`, { responseType: 'blob' });
export const deleteDocument = (id) => axios.delete(`${API_URL}/documents/${id}`);

// Notifications
export const getNotifications = () => axios.get(`${API_URL}/notifications`);
export const markNotificationRead = (id) => axios.put(`${API_URL}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API_URL}/notifications/read-all`);

// Dashboard
export const getAdminDashboard = (companyId) => axios.get(`${API_URL}/dashboard/admin`, { params: { company_id: companyId } });
export const getEmployeeDashboard = () => axios.get(`${API_URL}/dashboard/employee`);

// Calendar
export const getCalendarLeaves = (params) => axios.get(`${API_URL}/calendar/leaves`, { params });

// Password Management
export const changePassword = (currentPassword, newPassword) => 
  axios.post(`${API_URL}/auth/change-password`, { 
    current_password: currentPassword, 
    new_password: newPassword 
  });
export const forgotPassword = (email) => 
  axios.post(`${API_URL}/auth/forgot-password`, { email });
export const resetPassword = (token, newPassword) => 
  axios.post(`${API_URL}/auth/reset-password`, { token, new_password: newPassword });
export const verifyResetToken = (token) => 
  axios.get(`${API_URL}/auth/verify-reset-token?token=${token}`);
export const resetEmployeePassword = (employeeId, newPassword) => 
  axios.post(`${API_URL}/employees/${employeeId}/reset-password`, { new_password: newPassword });

// Admin/Manager Management
export const getAdmins = () => axios.get(`${API_URL}/admins`);
export const createAdmin = (data) => axios.post(`${API_URL}/admins`, data);
export const deleteAdmin = (id) => axios.delete(`${API_URL}/admins/${id}`);
export const updateAdmin = (id, data) => axios.put(`${API_URL}/admins/${id}`, data);

// ==================== FINANCEIRO ====================

// Empresas (financeiro)
export const getFinCompanies = () => axios.get(`${API_URL}/fin/companies`);
export const createFinCompany = (data) => axios.post(`${API_URL}/fin/companies`, data);
export const updateFinCompany = (id, data) => axios.put(`${API_URL}/fin/companies/${id}`, data);
export const deleteFinCompany = (id) => axios.delete(`${API_URL}/fin/companies/${id}`);

// Unidades / Lojas (financeiro)
export const getFinUnits = (companyId) =>
  axios.get(`${API_URL}/fin/units`, { params: companyId ? { company_id: companyId } : {} });
export const createFinUnit = (data) => axios.post(`${API_URL}/fin/units`, data);
export const updateFinUnit = (id, data) => axios.put(`${API_URL}/fin/units/${id}`, data);
export const deleteFinUnit = (id) => axios.delete(`${API_URL}/fin/units/${id}`);

// Equipa global (financeiro)
export const getFinTeam = () => axios.get(`${API_URL}/fin/team`);
export const addFinTeamMember = (data) => axios.post(`${API_URL}/fin/team`, data);
export const updateFinTeamMember = (memberId, role) =>
  axios.put(`${API_URL}/fin/team/${memberId}`, { role });
export const removeFinTeamMember = (memberId) => axios.delete(`${API_URL}/fin/team/${memberId}`);

// Faturas / Pagamentos (financeiro)
export const getFinInvoices = (companyId) =>
  axios.get(`${API_URL}/fin/invoices`, { params: { company_id: companyId } });
// Ficha de detalhe: fatura completa + linked_movement (movimento do extrato ligado, ou null)
export const getFinInvoice = (id) => axios.get(`${API_URL}/fin/invoices/${id}`);
export const getFinInvoicePdf = (id) => axios.get(`${API_URL}/fin/invoices/${id}/pdf`, { responseType: 'blob' });
// Secção Estoque — stock por loja (via app do Estoque, por proxy no backend RH)
export const getEstoqueLojas = () => axios.get(`${API_URL}/estoque/lojas`);
export const getEstoqueStock = (unidadeId) =>
  axios.get(`${API_URL}/estoque/stock`, { params: { unidade_id: unidadeId } });
export const getEstoqueListaCompras = (unidadeId) =>
  axios.get(`${API_URL}/estoque/lista-compras`, { params: { unidade_id: unidadeId } });
export const getEstoqueHistorico = (unidadeId, dias) =>
  axios.get(`${API_URL}/estoque/historico`, { params: { unidade_id: unidadeId, dias } });
// { tipo: entrada|saida|contagem, unidade_id, produto_id, quantidade }
export const estoqueMovimento = (data) => axios.post(`${API_URL}/estoque/movimento`, data);
// { unidade_id, destino_unidade_id, produto_id, quantidade }
export const estoqueTransferencia = (data) => axios.post(`${API_URL}/estoque/transferencia`, data);
// Fichas técnicas / receitas
// **Com tecto de espera, ao contrário do resto deste ficheiro.** O Estoque é
// outro serviço, noutro servidor: o proxy do portal já espera 12-15 s por ele
// antes de desistir, e sem `timeout` no browser (não há `axios.defaults.
// timeout` em lado nenhum deste repositório) um pedido pendurado deixava quem
// o fez a olhar para «A ler o catálogo…» para sempre — sem erro e sem fim.
export const getEstoqueProdutos = (marca) => axios.get(
  `${API_URL}/estoque/produtos`, { params: { marca }, timeout: 60000 });
export const getEstoqueReceita = (produtoId) => axios.get(`${API_URL}/estoque/produtos/${produtoId}/receita`);
// data: { rendimento, ingredientes:[{produto_id, quantidade}], tamanhos_balde:[kg] }
export const setEstoqueReceita = (produtoId, data) => axios.put(`${API_URL}/estoque/produtos/${produtoId}/receita`, data);
// Produção na fábrica
export const estoqueProduzir = (unidadeId, data) => axios.post(`${API_URL}/estoque/producao?unidade_id=${unidadeId}`, data);
export const getEstoqueProducao = (unidadeId, dias) => axios.get(`${API_URL}/estoque/producao`, { params: { unidade_id: unidadeId, dias } });
export const reverterEstoqueProducao = (producaoId) => axios.post(`${API_URL}/estoque/producao/${producaoId}/reverter`);

// Secção Estoque — Catálogo / Visão geral / Compras / Definições (Fase 1 do portal)
export const criarEstoqueProduto = (data) => axios.post(`${API_URL}/estoque/produtos`, data);
export const editarEstoqueProduto = (produtoId, data) => axios.patch(`${API_URL}/estoque/produtos/${produtoId}`, data);
export const apagarEstoqueProduto = (produtoId) => axios.delete(`${API_URL}/estoque/produtos/${produtoId}`);
export const mergeEstoqueProdutos = (data) => axios.post(`${API_URL}/estoque/produtos/merge`, data);
export const setEstoqueMaximo = (produtoId, unidadeId, maximo) =>
  axios.patch(`${API_URL}/estoque/stock/${produtoId}/maximo`, { maximo }, { params: { unidade_id: unidadeId } });
export const getEstoqueOverview = () => axios.get(`${API_URL}/estoque/overview`);
export const getEstoqueCompras = (marca) => axios.get(`${API_URL}/estoque/compras`, { params: { marca } });
export const getEstoqueComprasMakro = () => axios.get(`${API_URL}/estoque/compras-makro`);
export const getEstoqueDefinicoes = () => axios.get(`${API_URL}/estoque/definicoes`);
export const simularEstoqueDefinicao = (marca, percentagem) =>
  axios.get(`${API_URL}/estoque/definicoes/${marca}/simular`, { params: { percentagem } });
export const setEstoqueDefinicao = (marca, percentagem) => axios.patch(`${API_URL}/estoque/definicoes/${marca}`, { percentagem });

// Secção Estoque — Unidades / Utilizadores / Pessoas (Fase 2 do portal)
export const getEstoqueUnidades = () => axios.get(`${API_URL}/estoque/unidades`);
export const criarEstoqueUnidade = (data) => axios.post(`${API_URL}/estoque/unidades`, data);
export const editarEstoqueUnidade = (id, data) => axios.patch(`${API_URL}/estoque/unidades/${id}`, data);
export const getEstoqueUtilizadores = () => axios.get(`${API_URL}/estoque/utilizadores`);
export const criarEstoqueUtilizador = (data) => axios.post(`${API_URL}/estoque/utilizadores`, data);
export const editarEstoqueUtilizador = (id, data) => axios.patch(`${API_URL}/estoque/utilizadores/${id}`, data);
export const apagarEstoqueUtilizador = (id) => axios.delete(`${API_URL}/estoque/utilizadores/${id}`);
export const getEstoquePessoas = () => axios.get(`${API_URL}/estoque/pessoas`);
export const criarEstoquePessoa = (data) => axios.post(`${API_URL}/estoque/pessoas`, data);
export const editarEstoquePessoa = (id, data) => axios.patch(`${API_URL}/estoque/pessoas/${id}`, data);

// Secção Estoque — faturas inseridas pela app do Estoque (todos os estados)
// params: { company_id, month?, origin_user?, origin_store? }
export const getFinEstoqueInvoices = (params) =>
  axios.get(`${API_URL}/fin/estoque/invoices`, { params });
export const createFinInvoice = (data) => axios.post(`${API_URL}/fin/invoices`, data);
export const updateFinInvoice = (id, data) => axios.put(`${API_URL}/fin/invoices/${id}`, data);
export const toggleFinInvoicePaid = (id, paid, paidDate) =>
  axios.put(`${API_URL}/fin/invoices/${id}/toggle-paid`, { paid, paid_date: paidDate || null });
export const reclassifyFinInvoice = (id, companyId) =>
  axios.put(`${API_URL}/fin/invoices/${id}/reclassify`, { company_id: companyId });
export const setFinInvoiceUnit = (id, unitId) =>
  axios.put(`${API_URL}/fin/invoices/${id}/set-unit`, { unit_id: unitId || null });
export const deleteFinInvoice = (id) => axios.delete(`${API_URL}/fin/invoices/${id}`);
export const cancelFinInvoiceSeries = (id) =>
  axios.delete(`${API_URL}/fin/invoices/${id}`, { params: { series: 'future' } });
// Aprovação de faturas pendentes (ex.: entradas pela app do Estoque)
export const approveFinInvoice = (id, note) =>
  axios.put(`${API_URL}/fin/invoices/${id}/approve`, { note: note || null });
export const rejectFinInvoice = (id, note) =>
  axios.put(`${API_URL}/fin/invoices/${id}/reject`, { note: note || null });

// Regras de fornecedor (financeiro)
export const getFinSupplierRules = () => axios.get(`${API_URL}/fin/supplier-rules`);
export const upsertFinSupplierRule = (data) => axios.post(`${API_URL}/fin/supplier-rules`, data);
export const deleteFinSupplierRule = (key) =>
  axios.delete(`${API_URL}/fin/supplier-rules`, { params: { key } });

// Extrato / Tesouraria — contas bancárias e movimentos (financeiro)
export const getFinBankAccounts = (companyId) =>
  axios.get(`${API_URL}/fin/bank-accounts`, { params: { company_id: companyId } });
export const createFinBankAccount = (data) => axios.post(`${API_URL}/fin/bank-accounts`, data);
export const getFinMovements = (params) => axios.get(`${API_URL}/fin/movements`, { params });
export const importFinMovements = (data) => axios.post(`${API_URL}/fin/movements/import`, data);
// Conciliação por sugestão (fatura ↔ movimento do extrato)
export const getFinReconcileSuggestions = (companyId) =>
  axios.get(`${API_URL}/fin/reconcile/suggestions`, { params: { company_id: companyId } });
export const dismissFinReconcileSuggestion = (data) => axios.post(`${API_URL}/fin/reconcile/dismiss`, data);
// Fecho de tesouraria: o que falta conciliar no mês (movimentos por ligar + faturas por pagar)
export const getFinReconcilePending = (companyId, month) =>
  axios.get(`${API_URL}/fin/reconcile/pending`, { params: { company_id: companyId, month } });
// Auto-confirmar conciliações por carimbo aprendido (Fase 2)
export const runFinReconcileAuto = (companyId) =>
  axios.post(`${API_URL}/fin/reconcile/auto`, { company_id: companyId });
export const importFinMovementsPdf = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API_URL}/fin/movements/import-pdf`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const setFinMovementTitle = (id, title) =>
  axios.put(`${API_URL}/fin/movements/${id}/set-title`, { title });
// Conciliação: guarda campo a campo (o que não for enviado não é tocado).
export const updateFinMovement = (id, campos) =>
  axios.put(`${API_URL}/fin/movements/${id}`, campos);
export const createFinMovement = (data) => axios.post(`${API_URL}/fin/movements`, data);
export const deleteFinMovement = (id) => axios.delete(`${API_URL}/fin/movements/${id}`);
// Saldo de cada conta (cartão "Valor Contas" da Conciliação).
export const getFinBankBalances = (companyId) =>
  axios.get(`${API_URL}/fin/bank-accounts/balances`, { params: { company_id: companyId } });
export const linkFinMovement = (id, invoiceId) =>
  axios.put(`${API_URL}/fin/movements/${id}/link`, { invoice_id: invoiceId });
export const unlinkFinMovement = (id) => axios.put(`${API_URL}/fin/movements/${id}/unlink`);
export const attachFinMovement = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API_URL}/fin/movements/${id}/attach`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const automatchFinMovements = (companyId) =>
  axios.post(`${API_URL}/fin/movements/automatch`, { company_id: companyId });

// Vendas (financeiro) — params: { company_id, month?, unit_id? }
export const getFinSales = (params) => axios.get(`${API_URL}/fin/sales`, { params });
export const createFinSale = (data) => axios.post(`${API_URL}/fin/sales`, data);
export const updateFinSale = (id, data) => axios.put(`${API_URL}/fin/sales/${id}`, data);
export const deleteFinSale = (id) => axios.delete(`${API_URL}/fin/sales/${id}`);
export const syncFinVendus = (companyId, withCost = false) =>
  axios.post(`${API_URL}/fin/vendus/sync`, { company_id: companyId, with_cost: withCost });
// Despachante: escolhe o motor (Vendus/Moloni) consoante a empresa.
export const syncFinSales = (companyId, withCost = false) =>
  axios.post(`${API_URL}/fin/sales/sync`, { company_id: companyId, with_cost: withCost });

// Botões de atualização instantânea (Painel Global) — um por sistema.
export const syncNowVendus = () => axios.post(`${API_URL}/fin/sync/vendus`);
export const syncNowMoloni = () => axios.post(`${API_URL}/fin/sync/moloni`);
export const syncNowIngest = () => axios.post(`${API_URL}/fin/sync/ingest`);

// Dashboard de vendas (KPIs + gráficos) — params: { company_id, unit_id? }
export const getFinSalesDashboard = (params) => axios.get(`${API_URL}/fin/reports/vendas-dashboard`, { params });

// Relatórios (financeiro) — params: { company_id, start?, end? }
export const getFinReportIva = (params) => axios.get(`${API_URL}/fin/reports/iva`, { params });
export const getFinReportDre = (params) => axios.get(`${API_URL}/fin/reports/dre`, { params });
export const getFinReportTesouraria = (params) => axios.get(`${API_URL}/fin/reports/tesouraria`, { params });
export const getFinReportExport = (params) => axios.get(`${API_URL}/fin/reports/export`, { params, responseType: 'blob' });

// Painel Global (financeiro) — cruza KPIs Financeiro + RH + Marketing por empresa
// params: { company_id, month?, unit_id? } — mês manda nos fluxos (vendas/pago);
// a_pagar/vencidas/saldo são saldos "agora". unit_id = loja do seletor global.
export const getFinGlobalDashboard = (params) =>
  axios.get(`${API_URL}/fin/global/dashboard`, { params });
// Ligação empresa/unidade do Financeiro ao RH
export const linkFinCompanyRh = (id, rhCompanyId) =>
  axios.put(`${API_URL}/fin/companies/${id}/link-rh`, { rh_company_id: rhCompanyId });
export const linkFinUnitRh = (id, rhLocationId) =>
  axios.put(`${API_URL}/fin/units/${id}/link-rh`, { rh_location_id: rhLocationId });

// Marketing — Campanhas
export const getCampaigns = (params) => axios.get(`${API_URL}/marketing/campaigns`, { params });
export const createCampaign = (data) => axios.post(`${API_URL}/marketing/campaigns`, data);
export const updateCampaign = (id, data) => axios.put(`${API_URL}/marketing/campaigns/${id}`, data);
export const deleteCampaign = (id) => axios.delete(`${API_URL}/marketing/campaigns/${id}`);

// Marketing — Calendário de conteúdos (publicações)
export const getPosts = (params) => axios.get(`${API_URL}/marketing/posts`, { params });
export const createPost = (data) => axios.post(`${API_URL}/marketing/posts`, data);
export const updatePost = (id, data) => axios.put(`${API_URL}/marketing/posts/${id}`, data);
export const deletePost = (id) => axios.delete(`${API_URL}/marketing/posts/${id}`);

// Marketing — Avaliações (Google)
export const getReviews = (params) => axios.get(`${API_URL}/marketing/reviews`, { params });
export const findPlace = (query) => axios.get(`${API_URL}/marketing/reviews/find-place`, { params: { query } });

// Marketing — Relatórios / métricas
export const getMarketingReports = (params) => axios.get(`${API_URL}/marketing/reports`, { params });

// Escala do próprio colaborador (para o lembrete de ponto no app)
export const getMySchedule = () => axios.get(`${API_URL}/me/schedule`);

// RH — Feriados personalizados (municipais)
export const getHolidays = () => axios.get(`${API_URL}/holidays`);
export const createHoliday = (data) => axios.post(`${API_URL}/holidays`, data);
export const updateHoliday = (id, data) => axios.put(`${API_URL}/holidays/${id}`, data);
export const deleteHoliday = (id) => axios.delete(`${API_URL}/holidays/${id}`);
